import React, { useState } from "react";
import { IoIosNotificationsOutline } from "react-icons/io";
import { AiOutlineLogin } from "react-icons/ai";
import { RiArrowDropDownLine } from "react-icons/ri";
import { FaRegUserCircle } from "react-icons/fa";
import avatar from "../assets/images/avatar-icon.svg";
import downwardArrow from "../assets/images/downward-arrow.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Header.css";

const Header = ({ handleLogin }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const admin = JSON.parse(localStorage.getItem("admin"));

  const handleLogout = () => {
    localStorage.removeItem("admin");
    localStorage.removeItem("expiresAt");
    handleLogin(null);
  };

  return (
    <header
      className="d-flex justify-content-end align-items-center px-4 shadow-sm header-admin"
      style={{ backgroundColor: "#fff", fontSize: "14px", padding: "21px"}}
    >
      <div className="d-flex align-items-center">

        <div className="d-flex align-items-center position-relative">
          
          <div className="ms-2 dropdown" onClick={() => setDropdownOpen(!dropdownOpen)} style={{ cursor: "pointer", position: "relative" }} >
            <span className="fw-bold d-flex align-items-center" style={{ fontSize: "24px", gap: '10px'}} >
              <img src={avatar} alt="avatar" style={{width: '38px',}} />
              <div>
                {admin?.name || "Admin"} 
                <img src={downwardArrow} alt="avatar" style={{width: '15px',marginLeft: '5px'}} />
              </div>
            </span>
            {dropdownOpen && (
              <ul className="dropdown-menu dropdown-menu-end show"
                style={{ position: "absolute", right: 0, top: "47px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", borderRadius: "8px", }} >
                <li>
                  <button className="dropdown-item d-flex align-items-center" onClick={handleLogout} style={{ fontSize: "14px" }} >
                    <AiOutlineLogin size={18} className="me-2" /> Sign Out
                  </button>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
